import { SessionGuideLineProps } from "@/app/activity/components/guideline/sessionGuideline/type"
import { colors } from "@/components/colors"
import { HOUR_TO_SECOND_FORMAT } from "@/constants/regex"
import { format } from "date-fns"
import { useEffect, useMemo } from "react"

export default function SessionGuideLine({
  isDateVisible,
  date,
  position,
  onClick,
  originX = "center",
  originY = "top",
}: SessionGuideLineProps) {
  const backgroundX = useMemo(() => {
    switch (originX) {
      case "center":
        return "-25"
      case "left":
        return "-50"
      case "right":
        return "0"
    }
  }, [originX])

  const backgroundY = useMemo(() => {
    switch (originY) {
      case "top":
        return "2"

      case "bottom":
        return "80"
    }
  }, [originY])

  const textAnchor = useMemo(() => {
    switch (originX) {
      case "center":
        return "middle"
      case "left":
        return "end"
      case "right":
        return "start"
    }
  }, [originX])

  const textX = useMemo(() => {
    switch (originX) {
      case "center":
        return 0
      case "left":
        return -5
      case "right":
        return 5
    }
  }, [originX])

  const textY = useMemo(() => {
    switch (originY) {
      case "top":
        return "11"
      case "bottom":
        return "92"
    }
  }, [originY])

  useEffect(() => {
    if (!onClick) {
      return
    }

    if (onClick) {
      document.addEventListener("click", onClick as unknown as EventListener)

      return () => {
        document.removeEventListener("click", onClick as unknown as EventListener)
      }
    }
  }, [onClick])

  return (
    <g
      className="SessionGuideLine"
      transform={`translate(${position - 1}, 0)`}
      onMouseOver={(e) => {
        window.dispatchEvent(new CustomEvent("mouseover", e))
      }}
      onMouseMove={(e) => {
        window.dispatchEvent(new CustomEvent("mousemove", e))
      }}
      onMouseEnter={(e) => {
        window.dispatchEvent(new CustomEvent("mouseenter", e))
      }}>
      <line x1="0" y1="2" y2="100%" strokeWidth={1} className="SessionGuideLine__line" />
      <line
        x1="0"
        y1="2"
        y2="100%"
        stroke="black"
        strokeWidth={1}
        className="SessionGuideLine__line"
        strokeDasharray="2"
        fill={colors.neutral.black}
      />
      {isDateVisible && (
        <>
          <rect width="52" height="16" x={backgroundX} y={backgroundY} rx="3" ry="3" fill="black" />
          <text
            className="guideline-text"
            dominantBaseline={originY === "top" ? "middle" : originX}
            textAnchor={textAnchor}
            x={textX}
            y={textY}
            fill="white"
            fontSize={11}
            fontWeight={600}
            fontFamily="Montserrat">
            {date && format(date, HOUR_TO_SECOND_FORMAT)}
          </text>
        </>
      )}
    </g>
  )
}
